var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('appointmentService',{attrs:{"downTitle":_vm.downTitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }